<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M19.734 16a3.733 3.733 0 11-7.467 0 3.733 3.733 0 017.467 0z"/><path fill-rule="evenodd" d="M2.667 10.702c0-1.104.814-2 1.818-2H4.5v-.701h2.667v.701h.002c.597 0 1.155-.321 1.495-.86L9.7 6.194c.34-.54.899-.861 1.495-.861h9.141a1.75 1.75 0 011.358.67l1.643 2.029c.345.426.839.67 1.358.67h2.82c1.005 0 1.819.895 1.819 2v13.964c0 1.105-.814 2-1.819 2H4.485c-1.004 0-1.818-.895-1.818-2V10.702zm18.667 5.299a5.333 5.333 0 11-10.667 0 5.333 5.333 0 0110.667 0zm4.497-2.498a.667.667 0 01-.67.662l-1.334-.01a.667.667 0 01-.662-.67l.004-.667a.667.667 0 01.671-.662l1.334.009a.667.667 0 01.662.671l-.005.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsCameraFilled'
}
</script>
